import { Reducer } from 'redux';
import { PersonalInfoState, PersonalInfoActionTypes } from './types';
import { StudentActionTypes, Q } from '../types';
import { AppliedEUSSStatus, IDataCountry } from 'types';
import { countries } from 'data';

const initialState: PersonalInfoState = {
  givenName: '',
  middleName: '',
  surname: '',
  otherNames: [],
  hasEnglishTest: undefined,
  englishTestType: '',
  englishTestTypeOther: '',
  dob: '',
  phoneNumber: '',
  nationality: '',
  appliedForEUSS: undefined,
  grantedEUSSStatus: undefined,
  otherNationalities: [],
  birthCountry: '',
  gender: '',
  applyingFromHomeCountry: undefined,
  livedInUKLast12Months: undefined,
  otherCountryReason: '',
  homeAddress: '',
  city: '',
  postCode: '',
  country: '',
  hasCriminalConvictions: undefined,
  criminalConvictionReason: '',
  studentNo: '',
  passportNumber: '',
  passportStatus: '',
  passportExpiryDate: '',
  passportExpectedDate: '',
  withAgent: '',
  useWhatsapp: '',
  whatsAppPhoneNumber: ''
};

const reducer: Reducer<PersonalInfoState> = (state = initialState, action): PersonalInfoState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.personalInfo
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS: {
      return {
        ...state,
        ...action.payload.personalInfo
      };
    }
    case PersonalInfoActionTypes.UPDATE_PI_FIELD: {
      switch (action.payload.fieldName) {
        case Q.NATIONALITY: {
          const isEUSSNationality =
            countries.find((item: IDataCountry) => item.nationality === action.payload.value)?.category === 'EUSS';
          if (isEUSSNationality) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.IS_COUNTRY_OF_NATIONALITY]: undefined,
              [Q.COUNTRY_OF_VISA_APPLICATION]: '',
              [Q.REASON_WHY_NOT_COUNTRY_OF_NATIONALITY]: '',
              [Q.LIVED_IN_UK_LAST_12_MONTHS]: undefined
            };
          } else {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.APPLIED_FOR_EUSS]: undefined,
              [Q.GRANTED_EUSS_STATUS]: undefined
            };
          }
        }
        case Q.APPLIED_FOR_EUSS: {
          if (action.payload.value !== AppliedEUSSStatus.GRANTED) {
            state[Q.GRANTED_EUSS_STATUS] = undefined;
          }
          if (action.payload.value !== AppliedEUSSStatus.NO) {
            state[Q.IS_COUNTRY_OF_NATIONALITY] = undefined;
            state[Q.COUNTRY_OF_VISA_APPLICATION] = '';
            state[Q.REASON_WHY_NOT_COUNTRY_OF_NATIONALITY] = '';
            state[Q.LIVED_IN_UK_LAST_12_MONTHS] = undefined;
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_OTHER_NATIONALITY: {
          if (action.payload.value) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value
            };
          } else {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.OTHER_NATIONALITIES]: []
            };
          }
        }
        case Q.HAS_CRIMINAL_CONVICTIONS: {
          if (action.payload.value === false) {
            return {
              ...state,
              [Q.CRIMINAL_CONVICTIONS_REASON]: '',
              [action.payload.fieldName]: action.payload.value
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_ENGLISH_TEST: {
          if (action.payload.value === false) {
            return {
              ...state,
              [Q.ENGLISH_TEST_TYPE]: '',
              [Q.ENGLISH_TEST_TYPE_OTHER]: '',
              [action.payload.fieldName]: action.payload.value
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.ENGLISH_TEST_TYPE: {
          if (action.payload.value !== 'Other') {
            return {
              ...state,
              [Q.ENGLISH_TEST_TYPE_OTHER]: '',
              [action.payload.fieldName]: action.payload.value
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.HAS_OTHER_NAMES: {
          if (action.payload.value === false) {
            return {
              ...state,
              [action.payload.fieldName]: action.payload.value,
              [Q.OTHER_NAMES]: []
            };
          }
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        case Q.AGENT: {
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
        default: {
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
        }
      }
    }

    default:
      return state;
  }
};

export { reducer as personalInfoReducer };
